/**
 * Ícono de cada producto.
 *
 * Solución puente: mientras el catálogo no tenga fotos cargadas, se deduce un
 * emoji del nombre del plato. Suena tosco, pero en la práctica le da al
 * mesero un ancla visual para encontrar el producto sin leer — que es todo lo
 * que hace una foto en una grilla de 150 px.
 *
 * Cuando `producto.imagenUrl` empiece a venir poblado desde el backend, el
 * componente usa la foto y esta función queda solo como respaldo.
 */

const REGLAS: [RegExp, string][] = [
  [/hamburgues|burger/i, '🍔'],
  [/pizza/i, '🍕'],
  [/nugget|pollo|alit/i, '🍗'],
  [/churrasco|carne|lomo|res|punta/i, '🥩'],
  [/chicharr|cerdo|costilla/i, '🥓'],
  [/trucha|pescado|mojarra|camar/i, '🐟'],
  [/ajiaco|sopa|sancocho|crema/i, '🍲'],
  [/arroz|paella/i, '🍚'],
  [/ensalada|verdura/i, '🥗'],
  [/empanada|pastel/i, '🥟'],
  [/patac[oó]n|papa|yuca|frita/i, '🍟'],
  [/arepa|obleas|tortilla/i, '🫓'],
  [/perro|salchich/i, '🌭'],
  [/taco|burrito/i, '🌮'],
  [/cerveza|club|[aá]guila|corona/i, '🍺'],
  [/gaseosa|coca|cola|soda/i, '🥫'],
  [/limonada|coco/i, '🥥'],
  [/jugo|lulo|maracuy|mora|zumo/i, '🥤'],
  [/agua/i, '💧'],
  [/caf[eé]|tinto|capuchino|latte/i, '☕'],
  [/t[eé]\b|aromática/i, '🍵'],
  [/brownie|chocolate/i, '🍫'],
  [/helado|nieve/i, '🍨'],
  [/torta|ponqu[eé]|cheesecake/i, '🍰'],
  [/flan|natas|postre|arequipe/i, '🍮'],
];

export function iconoPorNombre(nombre: string): string {
  for (const [patron, emoji] of REGLAS) if (patron.test(nombre)) return emoji;
  return '🍽️';
}
